import { createContext } from 'react';

export const CampaignCreatorContext = createContext({
  campaignData: {},
  assignedModuleKeys: [],
  langKey: 'en',
  isPaywall: null,
});
